import { IAdminInsightsResult } from '../types/IAdminInsightsResult';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class AdminInsightsGetProjectIdRequest
    extends Request<{},IAdminInsightsResult> {

    constructor() {
        super('getAdminInsightsProjectId', {});
    }
}
